import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { typography, colors } from '@/styles';

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-size: 16px;
    font-weight: 500;
    line-height: 1.25;
`;
